const StatusCustomerService = {
  url: `${process.env.VUE_APP_API_URL}status-customer`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },

  create: async (step) => {
    try {
      const headers = StatusCustomerService.headers;

      const register_token = localStorage.getItem("register_token");
      headers["Register_Token"] = register_token;

      let data = {
        step: step,
        register_token: register_token,
      };

      const response = await fetch(`${StatusCustomerService.url}/create`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: StatusCustomerService.headers,
      });

      return response;
    } catch (e) {
      return false;
    }
  },
};

export default StatusCustomerService;
